/** Pregunta si añadir propiedades a la visita pendiente o crear una nueva. */
export default function ModalEleccionCitaExistente({
  isOpen,
  cita,
  onAnadirExistente,
  onNuevaCita,
  onClose,
  theme,
}) {
  if (!isOpen || !cita) return null;
  const c = theme?.colors || {};
  const isDark = theme?.name === "dark";

  let fechaTxt = "";
  if (cita.fecha_inicio) {
    try {
      fechaTxt = new Date(cita.fecha_inicio).toLocaleString("es-ES", {
        weekday: "short",
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      fechaTxt = "";
    }
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1500,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        background: "rgba(0,0,0,0.55)",
        fontFamily: "'DM Sans', sans-serif",
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "min(440px, 96vw)",
          borderRadius: 14,
          background: isDark ? c.bgCard : "#fff",
          border: `1px solid ${c.border || "#d4d4d8"}`,
          boxShadow: "0 16px 48px rgba(0,0,0,0.25)",
          overflow: "hidden",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: "18px 20px 12px" }}>
          <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: c.textPrimary }}>
            Visita pendiente
          </h3>
          <p style={{ margin: "10px 0 0", fontSize: 13, color: c.textSecondary, lineHeight: 1.5 }}>
            Este cliente ya tiene una visita programada
            {fechaTxt ? ` (${fechaTxt})` : ""}.
            ¿Qué quieres hacer con las propiedades seleccionadas?
          </p>
          {cita.titulo ? (
            <p style={{ margin: "8px 0 0", fontSize: 12, color: c.textMuted }}>
              {cita.titulo}
            </p>
          ) : null}
        </div>

        <div style={{ padding: "0 20px 16px", display: "flex", flexDirection: "column", gap: 10 }}>
          <button
            type="button"
            onClick={onAnadirExistente}
            style={{
              textAlign: "left",
              padding: "14px 16px",
              borderRadius: 10,
              border: "2px solid #06b6d4",
              background: "#06b6d4",
              color: "#fff",
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            <div style={{ fontSize: 14, fontWeight: 800 }}>Añadir a la visita existente</div>
            <div style={{ fontSize: 12, marginTop: 4, lineHeight: 1.4, opacity: 0.95 }}>
              Abre la cita actual para incluir las propiedades seleccionadas.
            </div>
          </button>
          <button
            type="button"
            onClick={onNuevaCita}
            style={{
              textAlign: "left",
              padding: "14px 16px",
              borderRadius: 10,
              border: `2px solid ${isDark ? c.border : "#c8c8be"}`,
              background: isDark ? c.bgInput : "#f4f4f0",
              color: c.textPrimary,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            <div style={{ fontSize: 14, fontWeight: 800 }}>Crear una visita nueva</div>
            <div style={{ fontSize: 12, marginTop: 4, lineHeight: 1.4, color: c.textSecondary }}>
              Programa otra cita independiente con las propiedades seleccionadas.
            </div>
          </button>
        </div>

        <div style={{ padding: "12px 20px", borderTop: `1px solid ${c.border || "#e4e4e7"}`, display: "flex", justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "8px 14px",
              borderRadius: 8,
              border: `1px solid ${c.border || "#d4d4d8"}`,
              background: "transparent",
              color: c.textSecondary,
              cursor: "pointer",
              fontFamily: "inherit",
              fontSize: 13,
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
